export const commonVars = {
  market_sentiment_cost: 100,
  market_presence_cost: 250,
}

export const allCountries = [
  { text: 'Aruba', value: 'Aruba' },
  { text: 'Afghanistan', value: 'Afghanistan' },
  { text: 'Angola', value: 'Angola' },
  { text: 'Anguilla', value: 'Anguilla' },
  { text: 'Åland Islands', value: 'Åland Islands' },
  { text: 'Albania', value: 'Albania' },
  { text: 'Andorra', value: 'Andorra' },
  { text: 'United Arab Emirates', value: 'United Arab Emirates' },
  { text: 'Argentina', value: 'Argentina' },
  { text: 'Armenia', value: 'Armenia' },
  { text: 'American Samoa', value: 'American Samoa' },
  { text: 'Antarctica', value: 'Antarctica' },
  { text: 'French Southern Territories', value: 'French Southern Territories' },
  { text: 'Antigua and Barbuda', value: 'Antigua and Barbuda' },
  { text: 'Australia', value: 'Australia' },
  { text: 'Austria', value: 'Austria' },
  { text: 'Azerbaijan', value: 'Azerbaijan' },
  { text: 'Burundi', value: 'Burundi' },
  { text: 'Belgium', value: 'Belgium' },
  { text: 'Benin', value: 'Benin' },
  {
    text: 'Bonaire, Sint Eustatius and Saba',
    value: 'Bonaire, Sint Eustatius and Saba',
  },
  { text: 'Burkina Faso', value: 'Burkina Faso' },
  { text: 'Bangladesh', value: 'Bangladesh' },
  { text: 'Bulgaria', value: 'Bulgaria' },
  { text: 'Bahrain', value: 'Bahrain' },
  { text: 'Bahamas', value: 'Bahamas' },
  { text: 'Bosnia and Herzegovina', value: 'Bosnia and Herzegovina' },
  { text: 'Saint Barthélemy', value: 'Saint Barthélemy' },
  { text: 'Belarus', value: 'Belarus' },
  { text: 'Belize', value: 'Belize' },
  { text: 'Bermuda', value: 'Bermuda' },
  {
    text: 'Bolivia, Plurinational State of',
    value: 'Bolivia, Plurinational State of',
  },
  { text: 'Brazil', value: 'Brazil' },
  { text: 'Barbados', value: 'Barbados' },
  { text: 'Brunei Darussalam', value: 'Brunei Darussalam' },
  { text: 'Bhutan', value: 'Bhutan' },
  { text: 'Bouvet Island', value: 'Bouvet Island' },
  { text: 'Botswana', value: 'Botswana' },
  { text: 'Central African Republic', value: 'Central African Republic' },
  { text: 'Canada', value: 'Canada' },
  { text: 'Cocos (Keeling) Islands', value: 'Cocos (Keeling) Islands' },
  { text: 'Switzerland', value: 'Switzerland' },
  { text: 'Chile', value: 'Chile' },
  { text: 'China', value: 'China' },
  { text: "Côte d'Ivoire", value: "Côte d'Ivoire" },
  { text: 'Cameroon', value: 'Cameroon' },
  {
    text: 'Congo, The Democratic Republic of the',
    value: 'Congo, The Democratic Republic of the',
  },
  { text: 'Congo', value: 'Congo' },
  { text: 'Cook Islands', value: 'Cook Islands' },
  { text: 'Colombia', value: 'Colombia' },
  { text: 'Comoros', value: 'Comoros' },
  { text: 'Cabo Verde', value: 'Cabo Verde' },
  { text: 'Costa Rica', value: 'Costa Rica' },
  { text: 'Cuba', value: 'Cuba' },
  { text: 'Curaçao', value: 'Curaçao' },
  { text: 'Christmas Island', value: 'Christmas Island' },
  { text: 'Cayman Islands', value: 'Cayman Islands' },
  { text: 'Cyprus', value: 'Cyprus' },
  { text: 'Czechia', value: 'Czechia' },
  { text: 'Germany', value: 'Germany' },
  { text: 'Djibouti', value: 'Djibouti' },
  { text: 'Dominica', value: 'Dominica' },
  { text: 'Denmark', value: 'Denmark' },
  { text: 'Dominican Republic', value: 'Dominican Republic' },
  { text: 'Algeria', value: 'Algeria' },
  { text: 'Ecuador', value: 'Ecuador' },
  { text: 'Egypt', value: 'Egypt' },
  { text: 'Eritrea', value: 'Eritrea' },
  { text: 'Western Sahara', value: 'Western Sahara' },
  { text: 'Spain', value: 'Spain' },
  { text: 'Estonia', value: 'Estonia' },
  { text: 'Ethiopia', value: 'Ethiopia' },
  { text: 'Finland', value: 'Finland' },
  { text: 'Fiji', value: 'Fiji' },
  { text: 'Falkland Islands (Malvinas)', value: 'Falkland Islands (Malvinas)' },
  { text: 'France', value: 'France' },
  { text: 'Faroe Islands', value: 'Faroe Islands' },
  {
    text: 'Micronesia, Federated States of',
    value: 'Micronesia, Federated States of',
  },
  { text: 'Gabon', value: 'Gabon' },
  { text: 'United Kingdom', value: 'United Kingdom' },
  { text: 'Georgia', value: 'Georgia' },
  { text: 'Guernsey', value: 'Guernsey' },
  { text: 'Ghana', value: 'Ghana' },
  { text: 'Gibraltar', value: 'Gibraltar' },
  { text: 'Guinea', value: 'Guinea' },
  { text: 'Guadeloupe', value: 'Guadeloupe' },
  { text: 'Gambia', value: 'Gambia' },
  { text: 'Guinea-Bissau', value: 'Guinea-Bissau' },
  { text: 'Equatorial Guinea', value: 'Equatorial Guinea' },
  { text: 'Greece', value: 'Greece' },
  { text: 'Grenada', value: 'Grenada' },
  { text: 'Greenland', value: 'Greenland' },
  { text: 'Guatemala', value: 'Guatemala' },
  { text: 'French Guiana', value: 'French Guiana' },
  { text: 'Guam', value: 'Guam' },
  { text: 'Guyana', value: 'Guyana' },
  { text: 'Hong Kong', value: 'Hong Kong' },
  {
    text: 'Heard Island and McDonald Islands',
    value: 'Heard Island and McDonald Islands',
  },
  { text: 'Honduras', value: 'Honduras' },
  { text: 'Croatia', value: 'Croatia' },
  { text: 'Haiti', value: 'Haiti' },
  { text: 'Hungary', value: 'Hungary' },
  { text: 'Indonesia', value: 'Indonesia' },
  { text: 'Isle of Man', value: 'Isle of Man' },
  { text: 'India', value: 'India' },
  {
    text: 'British Indian Ocean Territory',
    value: 'British Indian Ocean Territory',
  },
  { text: 'Ireland', value: 'Ireland' },
  { text: 'Iran, Islamic Republic of', value: 'Iran, Islamic Republic of' },
  { text: 'Iraq', value: 'Iraq' },
  { text: 'Iceland', value: 'Iceland' },
  { text: 'Israel', value: 'Israel' },
  { text: 'Italy', value: 'Italy' },
  { text: 'Jamaica', value: 'Jamaica' },
  { text: 'Jersey', value: 'Jersey' },
  { text: 'Jordan', value: 'Jordan' },
  { text: 'Japan', value: 'Japan' },
  { text: 'Kazakhstan', value: 'Kazakhstan' },
  { text: 'Kenya', value: 'Kenya' },
  { text: 'Kyrgyzstan', value: 'Kyrgyzstan' },
  { text: 'Cambodia', value: 'Cambodia' },
  { text: 'Kiribati', value: 'Kiribati' },
  { text: 'Saint Kitts and Nevis', value: 'Saint Kitts and Nevis' },
  { text: 'Korea, Republic of', value: 'Korea, Republic of' },
  { text: 'Kuwait', value: 'Kuwait' },
  {
    text: "Lao People's Democratic Republic",
    value: "Lao People's Democratic Republic",
  },
  { text: 'Lebanon', value: 'Lebanon' },
  { text: 'Liberia', value: 'Liberia' },
  { text: 'Libya', value: 'Libya' },
  { text: 'Saint Lucia', value: 'Saint Lucia' },
  { text: 'Liechtenstein', value: 'Liechtenstein' },
  { text: 'Sri Lanka', value: 'Sri Lanka' },
  { text: 'Lesotho', value: 'Lesotho' },
  { text: 'Lithuania', value: 'Lithuania' },
  { text: 'Luxembourg', value: 'Luxembourg' },
  { text: 'Latvia', value: 'Latvia' },
  { text: 'Macao', value: 'Macao' },
  { text: 'Saint Martin (French part)', value: 'Saint Martin (French part)' },
  { text: 'Morocco', value: 'Morocco' },
  { text: 'Monaco', value: 'Monaco' },
  { text: 'Moldova, Republic of', value: 'Moldova, Republic of' },
  { text: 'Madagascar', value: 'Madagascar' },
  { text: 'Maldives', value: 'Maldives' },
  { text: 'Mexico', value: 'Mexico' },
  { text: 'Marshall Islands', value: 'Marshall Islands' },
  { text: 'North Macedonia', value: 'North Macedonia' },
  { text: 'Mali', value: 'Mali' },
  { text: 'Malta', value: 'Malta' },
  { text: 'Myanmar', value: 'Myanmar' },
  { text: 'Montenegro', value: 'Montenegro' },
  { text: 'Mongolia', value: 'Mongolia' },
  { text: 'Northern Mariana Islands', value: 'Northern Mariana Islands' },
  { text: 'Mozambique', value: 'Mozambique' },
  { text: 'Mauritania', value: 'Mauritania' },
  { text: 'Montserrat', value: 'Montserrat' },
  { text: 'Martinique', value: 'Martinique' },
  { text: 'Mauritius', value: 'Mauritius' },
  { text: 'Malawi', value: 'Malawi' },
  { text: 'Malaysia', value: 'Malaysia' },
  { text: 'Mayotte', value: 'Mayotte' },
  { text: 'Namibia', value: 'Namibia' },
  { text: 'New Caledonia', value: 'New Caledonia' },
  { text: 'Niger', value: 'Niger' },
  { text: 'Norfolk Island', value: 'Norfolk Island' },
  { text: 'Nigeria', value: 'Nigeria' },
  { text: 'Nicaragua', value: 'Nicaragua' },
  { text: 'Niue', value: 'Niue' },
  { text: 'Netherlands', value: 'Netherlands' },
  { text: 'Norway', value: 'Norway' },
  { text: 'Nepal', value: 'Nepal' },
  { text: 'Nauru', value: 'Nauru' },
  { text: 'New Zealand', value: 'New Zealand' },
  { text: 'Oman', value: 'Oman' },
  { text: 'Pakistan', value: 'Pakistan' },
  { text: 'Panama', value: 'Panama' },
  { text: 'Pitcairn', value: 'Pitcairn' },
  { text: 'Peru', value: 'Peru' },
  { text: 'Philippines', value: 'Philippines' },
  { text: 'Palau', value: 'Palau' },
  { text: 'Papua New Guinea', value: 'Papua New Guinea' },
  { text: 'Poland', value: 'Poland' },
  { text: 'Puerto Rico', value: 'Puerto Rico' },
  {
    text: "Korea, Democratic People's Republic of",
    value: "Korea, Democratic People's Republic of",
  },
  { text: 'Portugal', value: 'Portugal' },
  { text: 'Paraguay', value: 'Paraguay' },
  { text: 'Palestine, State of', value: 'Palestine, State of' },
  { text: 'French Polynesia', value: 'French Polynesia' },
  { text: 'Qatar', value: 'Qatar' },
  { text: 'Réunion', value: 'Réunion' },
  { text: 'Romania', value: 'Romania' },
  { text: 'Russian Federation', value: 'Russian Federation' },
  { text: 'Rwanda', value: 'Rwanda' },
  { text: 'Saudi Arabia', value: 'Saudi Arabia' },
  { text: 'Sudan', value: 'Sudan' },
  { text: 'Senegal', value: 'Senegal' },
  { text: 'Singapore', value: 'Singapore' },
  {
    text: 'South Georgia and the South Sandwich Islands',
    value: 'South Georgia and the South Sandwich Islands',
  },
  {
    text: 'Saint Helena, Ascension and Tristan da Cunha',
    value: 'Saint Helena, Ascension and Tristan da Cunha',
  },
  { text: 'Svalbard and Jan Mayen', value: 'Svalbard and Jan Mayen' },
  { text: 'Solomon Islands', value: 'Solomon Islands' },
  { text: 'Sierra Leone', value: 'Sierra Leone' },
  { text: 'El Salvador', value: 'El Salvador' },
  { text: 'San Marino', value: 'San Marino' },
  { text: 'Somalia', value: 'Somalia' },
  { text: 'Saint Pierre and Miquelon', value: 'Saint Pierre and Miquelon' },
  { text: 'Serbia', value: 'Serbia' },
  { text: 'South Sudan', value: 'South Sudan' },
  { text: 'Sao Tome and Principe', value: 'Sao Tome and Principe' },
  { text: 'Suriname', value: 'Suriname' },
  { text: 'Slovakia', value: 'Slovakia' },
  { text: 'Slovenia', value: 'Slovenia' },
  { text: 'Sweden', value: 'Sweden' },
  { text: 'Eswatini', value: 'Eswatini' },
  { text: 'Sint Maarten (Dutch part)', value: 'Sint Maarten (Dutch part)' },
  { text: 'Seychelles', value: 'Seychelles' },
  { text: 'Syrian Arab Republic', value: 'Syrian Arab Republic' },
  { text: 'Turks and Caicos Islands', value: 'Turks and Caicos Islands' },
  { text: 'Chad', value: 'Chad' },
  { text: 'Togo', value: 'Togo' },
  { text: 'Thailand', value: 'Thailand' },
  { text: 'Tajikistan', value: 'Tajikistan' },
  { text: 'Tokelau', value: 'Tokelau' },
  { text: 'Turkmenistan', value: 'Turkmenistan' },
  { text: 'Timor-Leste', value: 'Timor-Leste' },
  { text: 'Tonga', value: 'Tonga' },
  { text: 'Trinidad and Tobago', value: 'Trinidad and Tobago' },
  { text: 'Tunisia', value: 'Tunisia' },
  { text: 'Turkey', value: 'Turkey' },
  { text: 'Tuvalu', value: 'Tuvalu' },
  { text: 'Taiwan, Province of China', value: 'Taiwan, Province of China' },
  {
    text: 'Tanzania, United Republic of',
    value: 'Tanzania, United Republic of',
  },
  { text: 'Uganda', value: 'Uganda' },
  { text: 'Ukraine', value: 'Ukraine' },
  {
    text: 'United States Minor Outlying Islands',
    value: 'United States Minor Outlying Islands',
  },
  { text: 'Uruguay', value: 'Uruguay' },
  { text: 'United States', value: 'United States' },
  { text: 'Uzbekistan', value: 'Uzbekistan' },
  {
    text: 'Holy See (Vatican City State)',
    value: 'Holy See (Vatican City State)',
  },
  {
    text: 'Saint Vincent and the Grenadines',
    value: 'Saint Vincent and the Grenadines',
  },
  {
    text: 'Venezuela, Bolivarian Republic of',
    value: 'Venezuela, Bolivarian Republic of',
  },
  { text: 'Virgin Islands, British', value: 'Virgin Islands, British' },
  { text: 'Virgin Islands, U.S.', value: 'Virgin Islands, U.S.' },
  { text: 'Viet Nam', value: 'Viet Nam' },
  { text: 'Vanuatu', value: 'Vanuatu' },
  { text: 'Wallis and Futuna', value: 'Wallis and Futuna' },
  { text: 'Samoa', value: 'Samoa' },
  { text: 'Yemen', value: 'Yemen' },
  { text: 'South Africa', value: 'South Africa' },
  { text: 'Zambia', value: 'Zambia' },
  { text: 'Zimbabwe', value: 'Zimbabwe' },
]

export const allIndustries = [
  { text: 'Agriculture', value: 'Agriculture' },
  { text: 'Energy & Chemicals', value: 'Energy & Chemicals' },
  { text: 'Food Production', value: 'Food Production' },
  { text: 'Precision Engineering', value: 'Precision Engineering' },
  { text: 'Wholesales Trade', value: 'Wholesales Trade' },
  { text: 'Manufacturing', value: 'Manufacturing' },
  { text: 'ICT & Media', value: 'ICT & Media' },
  { text: 'Waste Management', value: 'Waste Management' },
  { text: 'Construction', value: 'Construction' },
  { text: 'Retail', value: 'Retail' },
  { text: 'Land Transport', value: 'Land Transport' },
  { text: 'Sea Transport', value: 'Sea Transport' },
  { text: 'Marine & Offshore', value: 'Marine & Offshore' },
  { text: 'Air Transport', value: 'Air Transport' },
  { text: 'Aerospace', value: 'Aerospace' },
  { text: 'Logistics', value: 'Logistics' },
  { text: 'Leisure, Travel & Tourism', value: 'Leisure, Travel & Tourism' },
  { text: 'Financial Services', value: 'Financial Services' },
  { text: 'Real Estate', value: 'Real Estate' },
  { text: 'Professional Services', value: 'Professional Services' },
  { text: 'Healthcare', value: 'Healthcare' },
  { text: 'Staffing and Recruiting', value: 'Staffing and Recruiting' },
  { text: 'Security and Investigations', value: 'Security and Investigations' },
  { text: 'Environmental Services', value: 'Environmental Services' },
  { text: 'Public Service', value: 'Public Service' },
  { text: 'Education', value: 'Education' },
  { text: 'Social Services', value: 'Social Services' },
  {
    text: 'Community, Culture, Entertainment',
    value: 'Community, Culture, Entertainment',
  },
  {
    text: 'eSports',
    value: 'eSports',
  },
]

export const jobFunctions = [
  { text: 'Business Development', value: 'Business Development' },
  {
    text: 'Financial/Management Accounting',
    value: 'Financial/Management Accounting',
  },
  { text: 'Office Administration', value: 'Office Administration' },
  { text: 'Claims Processing', value: 'Claims Processing' },
  { text: 'Corporate Secretariat', value: 'Corporate Secretariat' },
  { text: 'Audit/Assurance', value: 'Audit/Assurance' },
  { text: 'Tax', value: 'Tax' },
  { text: 'Financial Forensics', value: 'Financial Forensics' },
  { text: 'Business Valuation', value: 'Business Valuation' },
  { text: 'Risk Advisory/Compliance', value: 'Risk Advisory/Compliance' },
  { text: 'Technology', value: 'Technology' },
]

export const specialIndustries = [
  { text: 'Sports', value: 'Sports' },
  { text: 'Country Club', value: 'Country Club' },
  { text: 'Hotel', value: 'Hotel' },
  { text: 'Attraction', value: 'Attraction' },
  { text: 'Lifestyle', value: 'Lifestyle' },
  { text: 'Meetings and Events', value: 'Meetings and Events' },
]

export const highestQualifications = [
  { text: 'Doctorate or equivalent', value: 'Doctorate or equivalent' },
  {
    text: "Master's Degree or equivalent",
    value: "Master's Degree or equivalent",
  },
  {
    text: "Bachelor's Degree or equivalent",
    value: "Bachelor's Degree or equivalent",
  },
  {
    text: 'Advanced/Specialist/Management/Graduate Diploma',
    value: 'Advanced/Specialist/Management/Graduate Diploma',
  },
  {
    text: 'Other Advanced Diploma/Post-Diploma Qualifications or equivalent',
    value: 'Other Advanced Diploma/Post-Diploma Qualifications or equivalent',
  },
  { text: 'Polytechnic Diploma', value: 'Polytechnic Diploma' },
  {
    text: 'Diploma Qualifications (e.g. NIE, SIM, LaSalle-SIA, NAFA)',
    value: 'Diploma Qualifications (e.g. NIE, SIM, LaSalle-SIA, NAFA)',
  },
  { text: 'ITE Diploma', value: 'ITE Diploma' },
  { text: 'WSQ Diploma', value: 'WSQ Diploma' },
  { text: 'WSQ Specialist Diploma', value: 'WSQ Specialist Diploma' },
  {
    text: 'Postgraduate Diploma/NIE Postgraduate Diploma',
    value: 'Postgraduate Diploma/NIE Postgraduate Diploma',
  },
  { text: 'WSQ Graduate Certificate', value: 'WSQ Graduate Certificate' },
  { text: 'WSQ Graduate Diploma', value: 'WSQ Graduate Diploma' },
  { text: 'Professional Certifications', value: 'Professional Certifications' },
  { text: "GCE 'A' Level", value: "GCE 'A' Level" },
  {
    text: 'Other Non-Tertiary or General Post-Secondary Qualifications/IB/High School Diploma',
    value: 'Other Non-Tertiary or General Post-Secondary Qualifications/IB/High School Diploma',
  },
  {
    text: 'Other Post-Secondary Non-Tertiary or Vocational Certificates',
    value: 'Other Post-Secondary Non-Tertiary or Vocational Certificates',
  },
  {
    text: 'Nitec, Certificate in Office Skills, NTC Grade 2 or equivalent',
    value: 'Nitec, Certificate in Office Skills, NTC Grade 2 or equivalent',
  },
  { text: 'Higher Nitec', value: 'Higher Nitec' },
  { text: 'Master Nitec or equivalent', value: 'Master Nitec or equivalent' },
  {
    text: 'WSQ Certificate/Career Readiness Certificate (Operations Level) or equivalent',
    value: 'WSQ Certificate/Career Readiness Certificate (Operations Level) or  equivalent',
  },
  {
    text: 'WSQ Higher Certificate or equivalent',
    value: 'WSQ Higher Certificate or equivalent',
  },
  {
    text: 'WSQ Advanced Certificate or equivalent',
    value: 'WSQ Advanced Certificate or equivalent',
  },
  { text: "GCE 'O' Level", value: "GCE 'O' Level" },
  { text: "GCE 'N' Level", value: "GCE 'N' Level" },
  {
    text: 'Nitec (Intermediate)/Certificate of Vocational Training/BCA Builder  Certificate/NTC Grade 3 or equivalent',
    value: 'Nitec (Intermediate)/Certificate of Vocational Training/BCA Builder Certificate/NTC Grade 3 or equivalent',
  },
  { text: 'ISC or equivalent', value: 'ISC or equivalent' },
  { text: 'ESS/ES WPLN 5 and above', value: 'ESS/ES WPLN 5 and above' },
  {
    text: 'Certificates or qualifications equivalent to Secondary education',
    value: 'Certificates or qualifications equivalent to Secondary education',
  },
  {
    text: 'Primary Education with PSLE/PSPE or equivalent',
    value: 'Primary Education with PSLE/PSPE or equivalent',
  },
  {
    text: 'Primary Education without PSLE/PSPE or equivalent',
    value: 'Primary Education without PSLE/PSPE or equivalent',
  },
  { text: 'BEST 1 - 3', value: 'BEST 1 - 3' },
  { text: 'BEST 4', value: 'BEST 4' },
  { text: 'ESS/ES WPLN 1 - 2', value: 'ESS/ES WPLN 1 - 2' },
  {
    text: "Secondary Education without GCE 'O'/'N' Level or equivalent",
    value: "Secondary Education without GCE 'O'/'N' Level or equivalent",
  },
  { text: 'WISE 1 - 3', value: 'WISE 1 - 3' },
  {
    text: 'Basic Vocational Certificate',
    value: 'Basic Vocational Certificate',
  },
  { text: 'ESS/ES WPLN 4', value: 'ESS/ES WPLN 4' },
  { text: 'Kindergarten Education', value: 'Kindergarten Education' },
  { text: 'No Formal Qualification', value: 'No Formal Qualification' },
  {
    text: 'Other Statement of Attainment, Modular Certificate or equivalent n.e.c.',
    value: 'Other Statement of Attainment, Modular Certificate or equivalent n.e.c.',
  }]

export const allCitizenships = [{ text: 'Afghan', value: 'Afghan' }, { text: 'Albanian', value: 'Albanian' }, { text: 'Algerian', value: 'Algerian' }, { text: 'American', value: 'American' }, { text: 'Andorran', value: 'Andorran' }, { text: 'Angolan', value: 'Angolan' }, { text: 'Antiguans', value: 'Antiguans' }, { text: 'Argentinean', value: 'Argentinean' }, { text: 'Armenian', value: 'Armenian' }, { text: 'Australian', value: 'Australian' }, { text: 'Austrian', value: 'Austrian' }, { text: 'Azerbaijani', value: 'Azerbaijani' }, { text: 'Bahamian', value: 'Bahamian' }, { text: 'Bahraini', value: 'Bahraini' }, { text: 'Bangladeshi', value: 'Bangladeshi' }, { text: 'Barbadian', value: 'Barbadian' }, { text: 'Barbudans', value: 'Barbudans' }, { text: 'Batswana', value: 'Batswana' }, { text: 'Belarusian', value: 'Belarusian' }, { text: 'Belgian', value: 'Belgian' }, { text: 'Belizean', value: 'Belizean' }, { text: 'Beninese', value: 'Beninese' }, { text: 'Bhutanese', value: 'Bhutanese' }, { text: 'Bolivian', value: 'Bolivian' }, { text: 'Bosnian', value: 'Bosnian' }, { text: 'Brazilian', value: 'Brazilian' }, { text: 'British', value: 'British' }, { text: 'Bruneian', value: 'Bruneian' }, { text: 'Bulgarian', value: 'Bulgarian' }, { text: 'Burkinabe', value: 'Burkinabe' }, { text: 'Burmese', value: 'Burmese' }, { text: 'Burundian', value: 'Burundian' }, { text: 'Cambodian', value: 'Cambodian' }, { text: 'Cameroonian', value: 'Cameroonian' }, { text: 'Canadian', value: 'Canadian' }, { text: 'Cape Verdean', value: 'Cape Verdean' }, { text: 'Central African', value: 'Central African' }, { text: 'Chadian', value: 'Chadian' }, { text: 'Chilean', value: 'Chilean' }, { text: 'Chinese', value: 'Chinese' }, { text: 'Colombian', value: 'Colombian' }, { text: 'Comoran', value: 'Comoran' }, { text: 'Congolese', value: 'Congolese' }, { text: 'Costa Rican', value: 'Costa Rican' }, { text: 'Croatian', value: 'Croatian' }, { text: 'Cuban', value: 'Cuban' }, { text: 'Cypriot', value: 'Cypriot' }, { text: 'Czech', value: 'Czech' }, { text: 'Danish', value: 'Danish' }, { text: 'Djibouti', value: 'Djibouti' }, { text: 'Dominican', value: 'Dominican' }, { text: 'Dutch', value: 'Dutch' }, { text: 'Dutchman', value: 'Dutchman' }, { text: 'Dutchwoman', value: 'Dutchwoman' }, { text: 'East Timorese', value: 'East Timorese' }, { text: 'Ecuadorean', value: 'Ecuadorean' }, { text: 'Egyptian', value: 'Egyptian' }, { text: 'Emirian', value: 'Emirian' }, { text: 'Equatorial Guinean', value: 'Equatorial Guinean' }, { text: 'Eritrean', value: 'Eritrean' }, { text: 'Estonian', value: 'Estonian' }, { text: 'Ethiopian', value: 'Ethiopian' }, { text: 'Fijian', value: 'Fijian' }, { text: 'Filipino', value: 'Filipino' }, { text: 'Finnish', value: 'Finnish' }, { text: 'French', value: 'French' }, { text: 'Gabonese', value: 'Gabonese' }, { text: 'Gambian', value: 'Gambian' }, { text: 'Georgian', value: 'Georgian' }, { text: 'German', value: 'German' }, { text: 'Ghanaian', value: 'Ghanaian' }, { text: 'Greek', value: 'Greek' }, { text: 'Grenadian', value: 'Grenadian' }, { text: 'Guatemalan', value: 'Guatemalan' }, { text: 'Guinea-Bissauan', value: 'Guinea-Bissauan' }, { text: 'Guinean', value: 'Guinean' }, { text: 'Guyanese', value: 'Guyanese' }, { text: 'Haitian', value: 'Haitian' }, { text: 'Herzegovinian', value: 'Herzegovinian' }, { text: 'Honduran', value: 'Honduran' }, { text: 'Hungarian', value: 'Hungarian' }, { text: 'I-Kiribati', value: 'I-Kiribati' }, { text: 'Icelander', value: 'Icelander' }, { text: 'Indian', value: 'Indian' }, { text: 'Indonesian', value: 'Indonesian' }, { text: 'Iranian', value: 'Iranian' }, { text: 'Iraqi', value: 'Iraqi' }, { text: 'Irish', value: 'Irish' }, { text: 'Israeli', value: 'Israeli' }, { text: 'Italian', value: 'Italian' }, { text: 'Ivorian', value: 'Ivorian' }, { text: 'Jamaican', value: 'Jamaican' }, { text: 'Japanese', value: 'Japanese' }, { text: 'Jordanian', value: 'Jordanian' }, { text: 'Kazakhstani', value: 'Kazakhstani' }, { text: 'Kenyan', value: 'Kenyan' }, { text: 'Kittian and Nevisian', value: 'Kittian and Nevisian' }, { text: 'Kuwaiti', value: 'Kuwaiti' }, { text: 'Kyrgyz', value: 'Kyrgyz' }, { text: 'Laotian', value: 'Laotian' }, { text: 'Latvian', value: 'Latvian' }, { text: 'Lebanese', value: 'Lebanese' }, { text: 'Liberian', value: 'Liberian' }, { text: 'Libyan', value: 'Libyan' }, { text: 'Liechtensteiner', value: 'Liechtensteiner' }, { text: 'Lithuanian', value: 'Lithuanian' }, { text: 'Luxembourger', value: 'Luxembourger' }, { text: 'Macedonian', value: 'Macedonian' }, { text: 'Malagasy', value: 'Malagasy' }, { text: 'Malawian', value: 'Malawian' }, { text: 'Malaysian', value: 'Malaysian' }, { text: 'Maldivan', value: 'Maldivan' }, { text: 'Malian', value: 'Malian' }, { text: 'Maltese', value: 'Maltese' }, { text: 'Marshallese', value: 'Marshallese' }, { text: 'Mauritanian', value: 'Mauritanian' }, { text: 'Mauritian', value: 'Mauritian' }, { text: 'Mexican', value: 'Mexican' }, { text: 'Micronesian', value: 'Micronesian' }, { text: 'Moldovan', value: 'Moldovan' }, { text: 'Monacan', value: 'Monacan' }, { text: 'Mongolian', value: 'Mongolian' }, { text: 'Moroccan', value: 'Moroccan' }, { text: 'Mosotho', value: 'Mosotho' }, { text: 'Motswana', value: 'Motswana' }, { text: 'Mozambican', value: 'Mozambican' }, { text: 'Namibian', value: 'Namibian' }, { text: 'Nauruan', value: 'Nauruan' }, { text: 'Nepalese', value: 'Nepalese' }, { text: 'Netherlander', value: 'Netherlander' }, { text: 'New Zealander', value: 'New Zealander' }, { text: 'Ni-Vanuatu', value: 'Ni-Vanuatu' }, { text: 'Nicaraguan', value: 'Nicaraguan' }, { text: 'Nigerian', value: 'Nigerian' }, { text: 'Nigerien', value: 'Nigerien' }, { text: 'North Korean', value: 'North Korean' }, { text: 'Northern Irish', value: 'Northern Irish' }, { text: 'Norwegian', value: 'Norwegian' }, { text: 'Omani', value: 'Omani' }, { text: 'Pakistani', value: 'Pakistani' }, { text: 'Palauan', value: 'Palauan' }, { text: 'Panamanian', value: 'Panamanian' }, { text: 'Papua New Guinean', value: 'Papua New Guinean' }, { text: 'Paraguayan', value: 'Paraguayan' }, { text: 'Peruvian', value: 'Peruvian' }, { text: 'Polish', value: 'Polish' }, { text: 'Portuguese', value: 'Portuguese' }, { text: 'Qatari', value: 'Qatari' }, { text: 'Romanian', value: 'Romanian' }, { text: 'Russian', value: 'Russian' }, { text: 'Rwandan', value: 'Rwandan' }, { text: 'Saint Lucian', value: 'Saint Lucian' }, { text: 'Salvadoran', value: 'Salvadoran' }, { text: 'Samoan', value: 'Samoan' }, { text: 'San Marinese', value: 'San Marinese' }, { text: 'Sao Tomean', value: 'Sao Tomean' }, { text: 'Saudi', value: 'Saudi' }, { text: 'Scottish', value: 'Scottish' }, { text: 'Senegalese', value: 'Senegalese' }, { text: 'Serbian', value: 'Serbian' }, { text: 'Seychellois', value: 'Seychellois' }, { text: 'Sierra Leonean', value: 'Sierra Leonean' }, { text: 'Singaporean', value: 'Singaporean' }, { text: 'Slovakian', value: 'Slovakian' }, { text: 'Slovenian', value: 'Slovenian' }, { text: 'Solomon Islander', value: 'Solomon Islander' }, { text: 'Somali', value: 'Somali' }, { text: 'South African', value: 'South African' }, { text: 'South Korean', value: 'South Korean' }, { text: 'Spanish', value: 'Spanish' }, { text: 'Sri Lankan', value: 'Sri Lankan' }, { text: 'Sudanese', value: 'Sudanese' }, { text: 'Surinamer', value: 'Surinamer' }, { text: 'Swazi', value: 'Swazi' }, { text: 'Swedish', value: 'Swedish' }, { text: 'Swiss', value: 'Swiss' }, { text: 'Syrian', value: 'Syrian' }, { text: 'Taiwanese', value: 'Taiwanese' }, { text: 'Tajik', value: 'Tajik' }, { text: 'Tanzanian', value: 'Tanzanian' }, { text: 'Thai', value: 'Thai' }, { text: 'Togolese', value: 'Togolese' }, { text: 'Tongan', value: 'Tongan' }, { text: 'Trinidadian or Tobagonian', value: 'Trinidadian or Tobagonian' }, { text: 'Tunisian', value: 'Tunisian' }, { text: 'Turkish', value: 'Turkish' }, { text: 'Tuvaluan', value: 'Tuvaluan' }, { text: 'Ugandan', value: 'Ugandan' }, { text: 'Ukrainian', value: 'Ukrainian' }, { text: 'Uruguayan', value: 'Uruguayan' }, { text: 'Uzbekistani', value: 'Uzbekistani' }, { text: 'Venezuelan', value: 'Venezuelan' }, { text: 'Vietnamese', value: 'Vietnamese' }, { text: 'Welsh', value: 'Welsh' }, { text: 'Yemenite', value: 'Yemenite' }, { text: 'Zambian', value: 'Zambian' }, { text: 'Zimbabwean', value: 'Zimbabwean' }]

export const genderOptions = [
  {
    text: 'Male',
    value: 'Male',
  },
  {
    text: 'Female',
    value: 'Female',
  },
]

export const employmentStatusOptions = [
  {
    text: 'Unemployed for less than 6 months',
    value: 'Unemployed for less than 6 months',
  },
  {
    text: 'Unemployed for more than 6 months',
    value: 'Unemployed for more than 6 months',
  },
  {
    text: 'Employed',
    value: 'Employed',
  },
]

export const citizenshipOptions = [
  {
    text: 'Singaporean',
    value: 'Singaporean',
  },
  {
    text: 'Singaporean PR',
    value: 'Singaporean PR',
  },
  {
    text: 'Others',
    value: 'Others',
  },
]

export const allAvailabilityOptions = [
  {
    text: 'Days',
    value: 'Days',
  },
  {
    text: 'Weeks',
    value: 'Weeks',
  },
  {
    text: 'Months',
    value: 'Months',
  },
]

export const prefWorkLocationOptions = [
  {
    text: 'Islandwide',
    value: 'Islandwide',
  },
  {
    text: 'Central',
    value: 'Central',
  },
  {
    text: 'South-East',
    value: 'South-East',
  },
  {
    text: 'South-West',
    value: 'South-West',
  },
  {
    text: 'North-East',
    value: 'North-East',
  },
  {
    text: 'North-West',
    value: 'North-West',
  },
]

export const applicationStatusOptions = [
  { text: 'Pending', value: 'Pending' },
  { text: 'Hired', value: 'Hired' },
  { text: 'Pending Interview', value: 'Pending Interview' },
  { text: 'Pending Assessment', value: 'Pending Assessment' },
  { text: 'Rejected', value: 'Rejected' },
  { text: 'Candidate Unresponsive', value: 'Candidate Unresponsive' },
  { text: 'Candidate Withdrew', value: 'Candidate Withdrew' },
  { text: 'Offer Sent', value: 'Offer Sent' },
  { text: 'Offer Declined', value: 'Offer Declined' },
  { text: 'References Checked', value: 'References Checked' },
  { text: 'Interviewed', value: 'Interviewed' },
  { text: 'Invited for Interview', value: 'Invited for Interview' },
  { text: 'Evaluated', value: 'Evaluated' },
  { text: 'Not yet Evaluated', value: 'Not yet Evaluated' },
  { text: 'Application was not submitted via MCF', value: 'Application was not submitted via MCF' },
]

export const applicationTypeOptions = [
  { text: 'Applied', value: 'Applied'},
  { text: 'Suggested', value: 'Suggested'},
]